import { useState } from "react";
import { get } from "../../../redux/ApiHelper";
import {
  PayoutInterface,
  PayoutStatusInterface,
  payoutTransactionInterface,
} from "../../../interfaces/payout.interface";
import { isBeforeTheTimeAndDate } from "../../../utils/helper.util";

interface PayoutStatusProps {
  row: PayoutInterface;
}


const PayoutStatus = ({ row }: PayoutStatusProps) => {
  const [payoutStatus, setPayoutStatus] = useState<PayoutStatusInterface>({
    total: 0,
    transactions: [],
    isSuccess: false,
    loading: false,
  });

  const statusRequst = () => {
    setPayoutStatus((prev) => ({ ...prev, loading: true }));

    get(`/admin/payout/request-status-payout/${row._id}`)
      .then((res) => {
        // console.log(res);
        setPayoutStatus((prev) => ({ ...prev, isSuccess: res.isSuccess }));
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setPayoutStatus((prev) => ({ ...prev, loading: false }));
      });
  };

  const isPaymentCompleted = row?.gatewayStatus === "COMPLETED";
  return (
    <div>
      {!isBeforeTheTimeAndDate(row.createdAt) &&
      row.adminAction === "Accepted" ? (
        <div className="space-y-2">
          {payoutStatus.isSuccess ? (
            <p className="text-green-500">COMPLETED</p>
          ) : (
            row?.gatewayStatus && (
              <p>
                Payment:{" "}
                <span
                  className={
                    isPaymentCompleted ? "text-green-500" : "text-red-500"
                  }
                >
                  {row?.gatewayStatus ?? ""}
                </span>
              </p>
            )
          )}
          {!isPaymentCompleted && (
            <button
              className="text-xs whitespace-nowrap p-1"
              onClick={statusRequst}
            >
              {payoutStatus.loading ? "Fetching.." : "Fetch Current Status"}
            </button>
          )}
        </div>
      ) : (
        <div></div>
      )}
    </div>
  );
};

export default PayoutStatus;
